import React, {useState, useEffect,} from 'react';
import Api from '../../Api';
import Butao from '../../Components/Butao_list';
import Campo from '../../Components/Campo';
import Header from '../../Components/Header';
import { Spinner  } from "react-awesome-spinners";
import FinderSelect from 'react-finderselect';
import { Web } from '@material-ui/icons';


export default ({ListEsp, setUsuariosContServ, UsuariosContServ,  Dados, Avisando, Fechar, Id, setAlert, setAlertTipo, MsgDesativar}) => {

const [Titulo, setTitulo] = useState("Criar Representantes");
const [MsgErro, setMsgErro] = useState("");
const [Loading, setLoading] = useState(false);
const [Nome, setNome] = useState("");
const [Telefone, setTelefone] = useState("");
const [PorcenMens, setPorcenMens] = useState("0000");
const [Cidade, setCidade] = useState("");
const [Estado, setEstado] = useState("");
const [Pix, setPix] = useState("");
const [NomePix, setNomePix] = useState("");
const [TelefoneRes, setTelefoneRes] = useState("");

useEffect(() => {
         PreencherFormulario()     
        }, [ListEsp])

const PreencherFormulario = () => {
      setNome(ListEsp.Nome);
      setTelefone(ListEsp.Telefone);
      setTelefoneRes(ListEsp.Telefone);
      setCidade(ListEsp.Cidade);
      setEstado(ListEsp.Estado);
      setPorcenMens(ListEsp.PorcenMens);
      setPix(ListEsp.Pix);
      setNomePix(ListEsp.NomePix);
  } 


  const criando = ()=>{

    // var TAAtualAno = parseInt(AtualAno)
     var TAPorcenMens = parseInt(PorcenMens)
    // var TADiaMes = parseInt(DiaMes)
    // var TAQuantApp = parseInt(QuantApp)
    // var TAValorApp = parseInt(ValorApp)


    

   
    if(TAPorcenMens >= 0){
    if(Nome !=="" && Nome !==" " && Nome !=="  " && Nome !=="   " && Nome !=="    " && Nome !=="     " && Nome !=="      "
    && Nome !=="       " && Nome !=="        " && Nome !=="         " && Nome !=="          " 
    && Nome !=="           " ){
      if (navigator.onLine) {
        setMsgErro("")
        setLoading(true) 
          
        Api.TAEditarRepresentante(Id, TelefoneRes, Dados, Nome, Telefone, Cidade, Estado, NomePix, Pix, PorcenMens, UsuariosContServ, setUsuariosContServ,  setMsgErro, setLoading, setAlertTipo, setAlert, );
 
      } else {
        setAlert("Sem Internet");
        setAlertTipo("danger");
      }
    } else {
        setMsgErro("Preencha o Nome Completo do Cliente.")
    }
    } else {
        setMsgErro("A porcentagem tem que ser maior que 0.")
    }
    
  }


  

 
        return (
            <>
<div className="content-wrapper">
                <Header 
                Titulo={Titulo}
                Avisando={Avisando}
                Fechar={Fechar}
                />
               <section className="content">
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-12">
            
              <div className="invoice p-3 mb-3">
              {/* title row */}
              <div className="row">
                <div className="col-12">
                  <h4>
                    <i className="fas fa-briefcase" /> Representante
                  </h4>
                </div>
                {/* /.col */}
              </div>
              {/* info row */}
              <div className="row invoice-info">
                <div className="col-sm-4 invoice-col">
                  <address>
                    {Loading  ?
                    <>
                      <Spinner 
                      size={64}
                      color={"#5d0bf7"}
                      sizeUnit={'px'} 
                      /><br />
                      </>
                      :
                      <>
                    <div className="col-12">
                        <Butao 
                        style={"btn .btn-sm btn-info"}
                        titulo={"Salvar"}
                        onClick={()=>criando()}
                        />  
                    </div><br />
                    
                     {MsgErro !== "" &&
                    <>
                    <div class="alert alert-danger alert-dismissible">
                  
                  <h5><i class="icon fas fa-ban"></i> Alert!</h5>
                  {MsgErro}
                </div>
                   
                    </>
                    }
                    </>
                    }
                    
                   
                    
                    <strong>Nome do Cliente</strong><br />
                    <div className="input_cadatro">
                             
                      
                      <input
                              type="text"
                              value={Nome}
                              onChange={t=>setNome(t.target.value)}
                              className="border p-2 rounded"
                              placeholder="Digite o Nome do Cliente"
                             
                            />
                            </div> 
                    <br />
    
                  <strong>Cidade</strong><br />
                    <div className="input_cadatro">
                              
                              <input
                              type="text"
                              value={Cidade}
                              onChange={t=>setCidade(t.target.value)}
                              className="border p-2 rounded"
                              placeholder="Digite a Cidade"
                            />

                            </div> 
                    <br /> 
                    <strong>Estado</strong><br />
                    <div className="input_cadatro">
                              
                              <input
                              type="text"
                              value={Estado}
                              onChange={t=>setEstado(t.target.value)}
                              className="border p-2 rounded"
                              placeholder="Digite a Estado"
                            />

                            </div> 
                    <br />   
                   
                     
                     
                 
                     
                  </address>
                    </div>
                      <div className="col-sm-4 invoice-col">
                    <address>
                   
                   <strong>Telefone do Cliente</strong><br />
                    <div className="input_cadatro">
                              
                              <Campo 
                                type={"tel"}
                                placeholder={"Digite Whatsapp"}
                                icon={"fas fa-phone"}
                                value={Telefone}
                                onChange={e=>setTelefone(e.target.value)}
                                mask={"(99)99999-9999"}
                                />

                            </div> 
                    <br />
                    
                    <strong>Nome do Pix</strong><br />
                    <div className="input_cadatro">
                             
                      
                      <input
                              type="text"
                              value={NomePix}
                              onChange={t=>setNomePix(t.target.value)}
                              className="border p-2 rounded"
                              placeholder="Digite o Nome do Cliente"
                             
                            />
                            </div> 
                    <br />
                    <strong>Número Pix</strong><br />
                    <div className="input_cadatro">
                             
                      
                      <input
                              type="text"
                              value={Pix}
                              onChange={t=>setPix(t.target.value)}
                              className="border p-2 rounded"
                              placeholder="Digite o Nome do Cliente"
                             
                            />
                            </div> 
                    <br />
                   
                     
                     <strong>Pagamento em Porcentagem %</strong><br />
                    <div className="input_cadatro">
                              
                              <input
                              type="text"
                              value={PorcenMens}
                              onChange={t=>setPorcenMens(t.target.value)}
                              maxLength={4}
                              className="border p-2 rounded"
                              placeholder="0000"
                              size={4}
                            />

                            </div> 
                    <br />
                    
                      
                    </address>
                   </div>
                    <div className="col-sm-4 invoice-col">
                    <address>
                     
                   

                   
                         
                    
                    </address>
                   </div>
              </div>
              <div className="row no-print">
              </div>
              
            
            </div> 
            </div>
            </div>
            </div>
          </section>
  
</div>

            </>
        );
}